module.exports = __webpack_public_path__ + "img/70.be97afb5.png";